const useRateFaqArticleDto = (
  options?: GraphqlMutationOptions<RateFaqArticleMutation, RateFaqArticleMutationVariables>,
) => {
  const mutation = useGraphqlMutation(RateFaqArticleSchema, options);

  return {
    ...mutation,
  };
};

export { useRateFaqArticleDto };
